import React from 'react'
import PropTypes from 'prop-types'
import CheckBox from '../CheckBox'
import FieldExtra from '../FieldExtra';
import './checkboxesArray.scss'

const CheckboxesArray = ({ onChange, onBlur, error, warning, valuesArray, options, className }) => {
  const checkboxes = options.map(({ label, value, disabled, disabledTitle }, index) => {
    const handleChange = (event) => {
      const arr = [...valuesArray]
      if (event.target.checked) {
        arr.push(value)
      } else {
        arr.splice(arr.indexOf(value), 1)
      }
      return onChange(arr)
    }
    const checked = valuesArray.includes(value)

    return (<CheckBox
      key={`checkbox-${index}`}
      onChange={handleChange}
      checked={checked}
      disabled={disabled}
      disabledTitle={disabledTitle}
      value={value}
      onBlur={() => onBlur(valuesArray)}
    >{label}</CheckBox>)
  })

  return <div className="Suc-checkboxes-array-container">
    <div className={`Suc-checkboxes-array ${className}`}>{checkboxes}</div>
    <FieldExtra error={error} warning={warning} marginTop="7px"/>
  </div>
}

const optionShape = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  disabledTitle: PropTypes.string
}

CheckboxesArray.propTypes = {
  /** callback run on change */
  onChange: PropTypes.func,
  /** callback run on blur */
  onBlur: PropTypes.func,
  /** array of string values */
  valuesArray: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  /** checked or unchecked */
  options: PropTypes.arrayOf(PropTypes.shape(optionShape)),
  /** custom classname */
  className: PropTypes.string
}

CheckboxesArray.defaultProps = {
  className: '',
  valuesArray: []
}

export default CheckboxesArray
